import * as API from "../../api";
import { batch } from "react-redux";
import * as ActionTypes from "../action-types";

import { message } from "antd";

// Constants and config
import { TIME } from "../../util";

// Redux actions
import { setLoadingPayroll, unsetLoadingPayroll } from "./style";
import { v1_billing, v1_company, v1_loyalty } from "./index";


const { lastNDay, latestTime } = TIME;

export const get_payroll_timeframe_thru_90days_request = () => (dispatch) => {
  batch(() => {
    dispatch(get_payroll_timeframe_all_request(lastNDay(90), latestTime));
    dispatch(v1_loyalty.get_all_loyalty_request());
    dispatch(v1_billing.get_billing_timeframe_request(lastNDay(90), latestTime));
  });
};

export const get_payroll_timeframe_all_request =
  (startTime, endTime) => (dispatch) => {
    dispatch(setLoadingPayroll());

    API.getPayrollTimeFrameAll({
      startTime,
      endTime,
    })
      .then((info) => {
        const { status, payrolls, msg } = info;

        if (status === 200) {
          dispatch(get_payroll_timeframe_all_success(payrolls));
          message.success("Successfully get payroll data");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        dispatch(unsetLoadingPayroll());
      });
  };

const get_payroll_timeframe_all_success = (payroll) => {
  return {
    type: ActionTypes.PAYROLL_GET_ALL,
    payroll,
  };
};

export const get_payroll_timeframe_by_coid_request = (coid) => (dispatch) => {
  batch(() => {
    dispatch(get_payroll_timeframe_by_coid_all_request(coid, lastNDay(90), latestTime));
    dispatch(v1_loyalty.get_all_loyalty_request());
  });
};

export const get_payroll_timeframe_by_coid_all_request =
  (coid, startTime, endTime) => (dispatch) => {
    dispatch(setLoadingPayroll());

    API.getPayrollTimeFrameByCoid({
      coid,
      startTime,
      endTime,
    })
      .then((info) => {
        const { status, payrolls, msg } = info;

        if (status === 200) {
          dispatch(get_payroll_timeframe_by_coid_all_success(payrolls));
          message.success("Successfully get payroll data");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        dispatch(unsetLoadingPayroll());
      });
  };

const get_payroll_timeframe_by_coid_all_success = (payroll) => {
  return {
    type: ActionTypes.PAYROLL_GET_ALL_BY_COID,
    payroll,
  };
};

export const update_payroll_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingPayroll());

  API.updatePayroll(items)
    .then((data) => {
        const { status, payroll, msg, remarkCount } = data;
        if (status === 200) {
          dispatch(update_payroll_success(payroll));
          dispatch(
            update_remarkcount_payroll_success({
              refid: payroll.prid,
              remarkCount,
            })
          );
          message.success("Update payroll data Successfully");
        } else {
          message.warning(msg);
        }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingPayroll());
    });
};

const update_payroll_success = (payroll) => {
  return {
    type: ActionTypes.UPDATE_PAYROLL,
    payroll,
  };
};

export const bulk_disbursed_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingPayroll());

  API.bulkDisbursed(items)
    .then((info) => {
      const { status, payrolls, msg } = info;

      if (status === 200) {
        dispatch(update_bulk_payroll_success(payrolls));
        message.success("Bulk Disbursed Successfully");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingPayroll());
    });
};

export const bulk_revert_processing_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingPayroll());

  API.bulkRevertProcessing(items)
    .then((info) => {
      const { status, payrolls, msg } = info;

      if (status === 200) {
        dispatch(update_bulk_payroll_success(payrolls));
        message.success("Bulk Revert for Processing Successfully");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingPayroll());
    });
};

export const generate_rhb_file_request = (items, cb) => (dispatch) => {
  API.generateRHB(items)
    .then((data) => {
      const { status, payrolls, msg } = data;
      if (status === 200) {
        dispatch(update_bulk_payroll_success(payrolls));
        message.success(msg);
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
    });
};

const update_bulk_payroll_success = (payrolls) => {
  return {
    type: ActionTypes.UPDATE_BULK_PAYROLL,
    payrolls,
  };
};

export const update_remarkcount_payroll_success = (remark) => {
  return {
    type: ActionTypes.UPDATE_REMARKCOUNT_PAYROLL,
    remark,
  };
};

export const payroll_file_close = (items, cb) => (dispatch) => {
  API.payrollFileClose(items)
    .then((data) => {
      const { status, payrolls, msg } = data;
      if (status === 200) {
        dispatch(payroll_file_close_success(payrolls));
        message.success(msg);
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
    });
}

const payroll_file_close_success = (payrolls) => {
  return {
    type: ActionTypes.UPDATE_PAYROLL_FILE_CLOSE,
    payrolls,
  };
};